import React from 'react';
import { CheckCircleOutline } from '@mui/icons-material';
import { useAgreementTemplateQuery } from '@uplift/queries';
import { StateExhibitSigned } from '@uplift/api';
import { CalendarDateService } from '@uplift/services';
import { DateFormats } from '@uplift/constants';
import { DocumentListItemRow } from './DocumentListItemRow';


export const StateExhibitListItem: React.VFC<{
  document: StateExhibitSigned;
  onClick: () => void;
  selected: boolean;
}> = ({
  document,
  onClick,
  selected,
}) => {
  const { data: template } = useAgreementTemplateQuery(document.agreementTemplateId);
  const signedOn = CalendarDateService.date(document.signedAt).format(DateFormats['MMM D, YYYY']);

  return (
    <DocumentListItemRow
      name={template.name}
      status={`Active · signed ${signedOn}`}
      statusColor="success"
      icon={<CheckCircleOutline />}
      onClick={onClick}
      selected={selected}
    />
  );
};
